import * as React from 'react';
import * as elementGroupStyles from './elementGroup/ElementGroup.css';
import * as styles from './Megamenu.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../stores';
import { ElementGroup } from './elementGroup/ElementGroup';
import { IAIcon } from '../../icon/Icon';
import { Burgerbar } from './topItems/sidebar/Burgerbar';
import { HorizontalBar } from './topItems/horizontalBar/HorizontalBar';
import 'element-matches';
import { Helper } from '../../../Helper';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { UPARROW_KEY_CODE } from '../../../global/Constants';
import { KeyNavigationGlobalCache } from '../KeyNavigationGlobalCache';

export interface IMegamenuProps {
  version: string;
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export class Megamenu extends React.Component<IMegamenuProps> {
  constructor(props: IMegamenuProps) {
    super(props);
  }

  public componentWillMount(): void {
    this.props.navigatorStore.getTopItems();
    this.checkLocationChange();
  }

  public componentWillReceiveProps(props: IMegamenuProps): void {
    if (props.version != this.props.version) {
      this.props.navigatorStore.getTopItems();
    }
  }

  private checkLocationChange(): void {
    window.addEventListener('popstate', () => this.closeMegaMenu());
    window.addEventListener('replaceState', () => this.closeMegaMenu());
    window.addEventListener('pushState', () => this.closeMegaMenu());
    const { pushState, replaceState } = window.history;
    window.history.pushState = (...args) => {
      pushState.apply(window.history, args);
      window.dispatchEvent(new Event('pushState'));
    };
    window.history.replaceState = (...args) => {
      replaceState.apply(window.history, args);
      window.dispatchEvent(new Event('replaceState'));
    };
  }

  private closeMegaMenu(): void {
    this.props.navigatorStore.isShowingMegamenu = false;
    this.props.navigatorStore.selectedTopMenuItemIndex = undefined;
  }

  private getTopItemContent(): JSX.Element[] {
    let topItemContent = [];
    let selectedTopItemIndex: number;
    if (
      (!this.props.navigatorStore.isMobile &&
        !this.props.navigatorStore.isIpadInPortrait &&
        this.props.navigatorStore.navigator.design.menuBar.showSlimPanel == undefined) ||
      (!this.props.navigatorStore.isMobile &&
        !this.props.navigatorStore.isIpadInPortrait &&
        !this.props.navigatorStore.navigator.design.menuBar.showSlimPanel) ||
      this.props.navigatorStore.isInEditMode ||
      this.props.navigatorStore.isClassic
    ) {
      this.props.navigatorStore.navigator.megamenu.topItems.forEach((topItem: any, topItemIndex) => {
        if (this.props.navigatorStore.selectedTopMenuItemIndex == topItemIndex) {
          selectedTopItemIndex = topItemIndex;
        }
        let columns: JSX.Element[] = [];
        let columnWidth;
        let numberOfColumns = this.props.navigatorStore.isInEditMode
          ? topItem.elementGroups.length + 1
          : topItem.elementGroups.length;
        let standardWidth: number = 440 * numberOfColumns + 55;
        let elementGroupsAreaWidth: number =
          this.props.navigatorStore.navigator.design.menuBar.layout === 'burger'
            ? this.props.navigatorStore.width - 300
            : this.props.navigatorStore.width;
        elementGroupsAreaWidth =
          this.props.navigatorStore.navigator.design.menuBar.layout === 'vertical' &&
            this.props.navigatorStore.verticalMenuExpanded
            ? elementGroupsAreaWidth - 300
            : elementGroupsAreaWidth;
        elementGroupsAreaWidth =
          this.props.navigatorStore.navigator.design.menuBar.layout === 'vertical' &&
            !this.props.navigatorStore.verticalMenuExpanded
            ? elementGroupsAreaWidth - 50
            : elementGroupsAreaWidth;
        if (standardWidth > elementGroupsAreaWidth) {
          columnWidth = (elementGroupsAreaWidth - 55) / numberOfColumns - 37;
        } else {
          columnWidth = 400;
        }
        topItem.elementGroups.forEach((column: any[], columnIndex) => {
          let elementGroups: JSX.Element[] = [];
          column.forEach((elementGroup: any, elementGroupIndex) => {
            if (this.props.navigatorStore.droppableElementGroupSpotsAreShowing) {
              elementGroups.push(
                <div
                  className={styles.elementGroupDroppable}
                  key={`elementGroupDroppable_${elementGroupIndex}`}
                  style={{
                    color: this.props.navigatorStore.navigator.design.elements.textColor,
                    border: `1px dashed ${this.props.navigatorStore.navigator.design.elements.textColor}`,
                    opacity: 0.5,
                  }}
                  onDragOver={() => event.preventDefault()}
                  onDragEnter={() => event.preventDefault()}
                  onDrop={() => {
                    this.props.navigatorStore.updateElementGroupPosition(topItemIndex, columnIndex, elementGroupIndex);
                  }}
                >
                  {new LocalizationService().strings.Navigator_Megamenu_DropItem}
                </div>
              );
            }
            if (this.props.navigatorStore.checktargetedPreviewIds(elementGroup)) {
              elementGroups.push(
                <ElementGroup
                  key={`elementGroups_${elementGroupIndex}`}
                  config={elementGroup.config}
                  elements={elementGroup.elements}
                  topItemIndex={topItemIndex}
                  columnIndex={columnIndex}
                  index={elementGroupIndex}
                  width={columnWidth}
                  type={elementGroup.type}
                />
              );
            }
          });
          if (this.props.navigatorStore.droppableElementGroupSpotsAreShowing) {
            elementGroups.push(
              <div
                className={styles.elementGroupDroppable}
                key={`elementGroupDroppableUnder_${columnIndex}`}
                style={{
                  color: this.props.navigatorStore.navigator.design.elements.textColor,
                  border: `1px dashed ${this.props.navigatorStore.navigator.design.elements.textColor}`,
                  opacity: 0.5,
                }}
                onDragOver={() => event.preventDefault()}
                onDragEnter={() => event.preventDefault()}
                onDrop={() => {
                  this.props.navigatorStore.updateElementGroupPosition(topItemIndex, columnIndex, column.length);
                }}
              >
                {new LocalizationService().strings.Navigator_Megamenu_DropItem}
              </div>
            );
          }
          columns.push(
            <div
              className={styles.column}
              style={{
                width: columnWidth != undefined ? columnWidth : 0,
              }}
              key={`column_${columnIndex}`}
            >
              {elementGroups}
              {this.props.navigatorStore.isInEditMode &&
                !this.props.navigatorStore.droppableElementGroupSpotsAreShowing &&
                !this.props.navigatorStore.droppableElementSpotsAreShowing &&
                !this.props.navigatorStore.droppableTopItemSpotsAreShowing && (
                  <div
                    className={elementGroupStyles.elementAddNewButton}
                    key={`elementAddNewButton1_${columnIndex}`}
                    style={{
                      height: 100,
                      border: `1px dashed ${this.props.navigatorStore.navigator.design.elementGroups.textColor}`,
                      width: 'calc(100% - 10px)',
                    }}
                    onClick={() => {
                      if (!this.props.navigatorStore.isShowingAnalytics && !this.props.navigatorStore.checkedOut) {
                        this.props.navigatorStore.addElementGroup(topItemIndex, columnIndex);
                      }
                    }}
                  >
                    <div className={elementGroupStyles.elementAddNewButtonIcon}>
                      <IAIcon
                        title="Add"
                        size={20}
                        color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
                      />
                    </div>
                    <div
                      className={elementGroupStyles.elementAddNewButtonText}
                      style={{
                        color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
                      }}
                    >
                      {new LocalizationService().strings.Navigator_Megamenu_AddGroup}
                    </div>
                  </div>
                )}
            </div>
          );
        });
        if (this.props.navigatorStore.isInEditMode) {
          columns.push(
            <div
              key={`column_${Helper.getRandomStringKey()}`}
              className={styles.column}
              style={{
                width: columnWidth,
                marginRight: 0,
              }}
            >
              {!this.props.navigatorStore.droppableElementGroupSpotsAreShowing &&
                !this.props.navigatorStore.droppableElementSpotsAreShowing &&
                !this.props.navigatorStore.droppableTopItemSpotsAreShowing && (
                  <div
                    className={elementGroupStyles.elementAddNewButton}
                    key={`elementAddNewButton2_${topItemIndex}`}
                    style={{
                      height: 100,
                      border: `1px dashed ${this.props.navigatorStore.navigator.design.elementGroups.textColor}`,
                      width: 'calc(100% - 10px)',
                    }}
                    onClick={() => {
                      if (!this.props.navigatorStore.isShowingAnalytics && !this.props.navigatorStore.checkedOut) {
                        this.props.navigatorStore.addElementGroup(topItemIndex);
                      }
                    }}
                  >
                    <div className={elementGroupStyles.elementAddNewButtonIcon}>
                      <IAIcon
                        title="Add"
                        size={20}
                        color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
                      />
                    </div>
                    <div
                      className={elementGroupStyles.elementAddNewButtonText}
                      style={{
                        color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
                      }}
                    >
                      {new LocalizationService().strings.Navigator_Megamenu_AddGroup}
                    </div>
                  </div>
                )}
              {!this.props.navigatorStore.droppableElementGroupSpotsAreShowing && (
                <div
                  className={elementGroupStyles.elementAddNewButton}
                  key={`elementAddNewButton3_${topItemIndex}`}
                  onClick={() => {
                    if (!this.props.navigatorStore.checkedOut && !this.props.navigatorStore.isShowingAnalytics) {
                      if (this.props.navigatorStore.droppableElementSpotsAreShowing) {
                        this.props.navigatorStore.hideDroppableElementSpots();
                      } else {
                        this.props.navigatorStore.showDroppableElementSpots();
                      }
                    }
                  }}
                >
                  <div className={elementGroupStyles.elementAddNewButtonIcon}>
                    <IAIcon
                      title={this.props.navigatorStore.droppableElementSpotsAreShowing ? 'Checkmark' : 'Move'}
                      size={20}
                      color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
                    />
                  </div>
                  <div
                    className={elementGroupStyles.elementAddNewButtonText}
                    style={{
                      color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
                      paddingLeft: 5,
                    }}
                  >
                    {this.props.navigatorStore.droppableElementSpotsAreShowing
                      ? new LocalizationService().strings.Navigator_Megamenu_DoneReordering
                      : new LocalizationService().strings.Navigator_Megamenu_ReorderItems}
                  </div>
                </div>
              )}
              {!this.props.navigatorStore.droppableElementSpotsAreShowing && (
                <div
                  className={elementGroupStyles.elementAddNewButton}
                  key={`elementAddNewButton4_${topItemIndex}`}
                  onClick={() => {
                    if (!this.props.navigatorStore.checkedOut && !this.props.navigatorStore.isShowingAnalytics) {
                      if (this.props.navigatorStore.droppableElementGroupSpotsAreShowing) {
                        this.props.navigatorStore.hideDroppableElementGroupSpots();
                      } else {
                        this.props.navigatorStore.showDroppableElementGroupSpots();
                      }
                    }
                  }}
                >
                  <div className={elementGroupStyles.elementAddNewButtonIcon}>
                    <IAIcon
                      title={this.props.navigatorStore.droppableElementGroupSpotsAreShowing ? 'Checkmark' : 'Move'}
                      size={20}
                      color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
                    />
                  </div>
                  <div
                    className={elementGroupStyles.elementAddNewButtonText}
                    style={{
                      color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
                      paddingLeft: 5,
                    }}
                  >
                    {this.props.navigatorStore.droppableElementGroupSpotsAreShowing
                      ? new LocalizationService().strings.Navigator_Megamenu_DoneReordering
                      : new LocalizationService().strings.Navigator_Megamenu_ReorderGroups}
                  </div>
                </div>
              )}
            </div>
          );
        }
        topItemContent.push(columns);
      });
    }
    if (
      this.props.navigatorStore.isIpadInPortrait ||
      (this.props.navigatorStore.navigator.design.menuBar.showSlimPanel &&
        !this.props.navigatorStore.isInEditMode &&
        this.props.navigatorStore.navigator.design.menuBar.layout == 'vertical')
    ) {
      this.props.navigatorStore.navigator.megamenu.topItems.forEach((topItem: any, topItemIndex) => {
        if (this.props.navigatorStore.selectedTopMenuItemIndex == topItemIndex) {
          selectedTopItemIndex = topItemIndex;
        }
        let columnWidth: number = this.props.navigatorStore.width;
        if (this.props.navigatorStore.navigator.design.menuBar.layout == 'burger') {
          columnWidth = this.props.navigatorStore.width - 340;
        }
        if (this.props.navigatorStore.navigator.design.menuBar.layout == 'vertical') {
          if (this.props.navigatorStore.verticalMenuExpanded) {
            columnWidth = this.props.navigatorStore.width - 340;
          } else {
            columnWidth = this.props.navigatorStore.width - 55;
          }
          if (this.props.navigatorStore.navigator.design.menuBar.showSlimPanel) {
            columnWidth = 510;
          }
        }
        let elementGroups: JSX.Element[] = [];
        topItem.elementGroups.forEach((column: any[], columnIndex) => {
          column.forEach((elementGroup: any, elementGroupIndex) => {
            if (this.props.navigatorStore.checktargetedPreviewIds(elementGroup)) {
              elementGroups.push(
                <ElementGroup
                  key={`elementGroup_${elementGroupIndex}_${topItemIndex}_${columnIndex}`}
                  config={elementGroup.config}
                  elements={elementGroup.elements}
                  topItemIndex={topItemIndex}
                  columnIndex={columnIndex}
                  index={elementGroupIndex}
                  width={columnWidth}
                  type={elementGroup.type}
                />
              );
            }
          });
        });
        topItemContent.push(
          <div
            key={`topItemContent_${topItemIndex}`}
            className={styles.column}
            style={{
              width: columnWidth != undefined ? columnWidth : 0,
            }}
          >
            {elementGroups}
          </div>
        );
      });
    }
    return topItemContent[selectedTopItemIndex];
  }

  render() {
    if (this.props.navigatorStore.navigator != undefined) {
      let design = this.props.navigatorStore.navigator.design;
      let megamenuWidth: number | string = this.props.navigatorStore.width;
      let megamenuMarginLeft = 0;
      if (design.menuBar.layout === 'vertical') {
        megamenuWidth = this.props.navigatorStore.verticalMenuExpanded
          ? this.props.navigatorStore.width - 250
          : this.props.navigatorStore.width;
        if (this.props.navigatorStore.isShowingMegamenu) {
          megamenuMarginLeft = this.props.navigatorStore.verticalMenuExpanded ? 250 : 0;
        } else {
          megamenuMarginLeft = -this.props.navigatorStore.width;
        }
        if (
          design.menuBar.showSlimPanel != undefined &&
          design.menuBar.showSlimPanel &&
          !this.props.navigatorStore.isInEditMode
        ) {
          megamenuWidth = 600;
        }
      }
      let megamenuContentWidth = design.menuBar.layout === 'burger' ? this.props.navigatorStore.width - 300 : '100%';
      let marginTop = 0;
      if (!isNaN(this.props.navigatorStore.contentTop) && !isNaN(this.props.navigatorStore.contentHeight)) {
        marginTop =
          design.menuBar.layout === 'vertical' || this.props.navigatorStore.isShowingMegamenu
            ? this.props.navigatorStore.contentTop
            : -(this.props.navigatorStore.contentTop + this.props.navigatorStore.contentHeight);
        if (design.menuBar.layout === 'burger' && this.props.navigatorStore.isShowingMegamenu) {
          marginTop = 0;
        }
      }
      if (this.props.navigatorStore.isInEditMode) {
        marginTop = design.menuBar.layout === 'vertical' ? 0 : marginTop - 48;
      }

      let mobileNavigatorOffsetHeight = 0;
      if (this.props.navigatorStore.isMobile) {
        megamenuWidth = "100%";
        marginTop = 0;

        if (!this.props.navigatorStore.asMobileAppComponent) {
          mobileNavigatorOffsetHeight += document.getElementById("SuiteNavWrapper")?.clientHeight ?? 0; // sp top menu
          mobileNavigatorOffsetHeight += document.getElementById("sp-appBar")?.clientHeight ?? 0; // sp bottom menu
          mobileNavigatorOffsetHeight += 40; // our own navigator is 40 px tall
          mobileNavigatorOffsetHeight += this.props.navigatorStore.navigatorTop;
        }
      }
      return (
        <>
          {design.menuBar.layout === 'horizontal' && <HorizontalBar />}
          {!this.props.navigatorStore.isMobile &&
            this.props.navigatorStore.isShowingMegamenu && !this.props.navigatorStore.isShowingAnalytics && (
              <div
                style={{
                  position: 'fixed',
                  height: document.documentElement.clientHeight,
                  width: document.body.clientWidth,
                  zIndex: 900000,
                  backgroundColor: 'rgba(255, 255, 255, 0.24)',
                }}
                onClick={() => {
                  this.props.navigatorStore.isShowingMegamenu = false;
                  this.props.navigatorStore.selectTopMenuItem(undefined);
                }}
              />
            )}
          <div
            className={styles.megamenu}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              var index = this.props.navigatorStore.selectedTopMenuItemIndex;
              if (event.which === UPARROW_KEY_CODE && (index || index === 0)) {
                event.preventDefault();
                KeyNavigationGlobalCache.topItemRefs[index].focus();
              }
            }}
            style={{
              backgroundColor: design.elementGroups.backgroundColor,
              width: megamenuWidth ?? 0,
              marginLeft: megamenuMarginLeft != undefined && !isNaN(megamenuMarginLeft) ? megamenuMarginLeft : 0,
              marginTop: design.menuBar.layout === 'burger' && this.props.navigatorStore.isInEditMode ? 0 : marginTop,
              top: design.menuBar.layout === 'burger' && !this.props.navigatorStore.asMobileAppComponent ? 40 : 0,
              zIndex: this.props.navigatorStore.isShowingAnalytics ? 900999 : 900001,
              opacity: this.props.navigatorStore.isShowingMegamenu ? 1 : 0,
              height: this.props.navigatorStore.asMobileAppComponent ? "100%" : (this.props.navigatorStore.isShowingMegamenu ? this.props.navigatorStore.isMobile ? `calc(100dvh - ${mobileNavigatorOffsetHeight}px)` : undefined : 0),
              transition: this.props.navigatorStore.isInEditMode
                ? 'opacity 200ms ease-in-out'
                : 'all 200ms ease-in-out',
            }}
          >
            {design.menuBar.layout === 'burger' && <Burgerbar />}
            {!this.props.navigatorStore.isMobile && (
              <div
                className={styles.megamenuContent}
                id="megamenuContent"
                style={{
                  width: megamenuContentWidth != undefined ? megamenuContentWidth : 0,
                  backgroundColor: design.elementGroups.backgroundColor,
                  maxHeight: this.props.navigatorStore.contentHeight,
                  padding: this.props.navigatorStore.isInEditMode && this.props.navigatorStore.checkedOut && (!this.props.navigatorStore.isShowingAnalytics || this.props.navigatorStore.selectedTopMenuItemIndex === undefined) ? 0 : "",
                  boxShadow: design.menuBar.layout === 'burger' ? undefined : "rgba(0, 0, 0, 0.2) 0px 0px 30px 0px"
                }}
              >
                {this.getTopItemContent()}
                {!this.props.navigatorStore.isInEditMode && (
                  <IAButton
                    style={{
                      right: 30,
                      top: 20,
                      position: 'absolute',
                    }}
                    icon="Close"
                    iconColor={this.props.navigatorStore.navigator.design.elements.textColor}
                    onClick={() => {
                      this.props.navigatorStore.isShowingMegamenu = false;
                      this.props.navigatorStore.selectTopMenuItem(undefined);
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </>
      );
    } else {
      return <div className={styles.megamenu}></div>;
    }
  }
}
